import React, { useContext, useState } from "react";
import { ConfirmDialog, IconButton, useNotifications } from "sprint-common-web";

import { useDeliveryBucketsApi } from "../../api/useDeliveryBucketsApi";
import { DeliveryBucketListingContext } from "../../context/DeliveryBucketListingContext";

interface DisableDeliveryBucketButtonProps {
    itemId: string;
}

export const DisableDeliveryBucketButton: React.VFC<DisableDeliveryBucketButtonProps> = ({
    itemId
}: DisableDeliveryBucketButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const { disableDeliveryBucket } = useDeliveryBucketsApi();
    const { success } = useNotifications();
    const { disableDeliveryBucketItem } = useContext(DeliveryBucketListingContext);

    const openDialog = () => {
        setIsDialogOpen(true);
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const handleDisable = async () => {
        await disableDeliveryBucket({ deliveryBucketId: itemId });

        success("Bucket succesfully disabled");
        disableDeliveryBucketItem(itemId);
        closeDialog();
    };

    return (
        <>
            <IconButton
                key={itemId}
                iconProps={{ iconName: "Blocked" }}
                tooltipContent="Disable"
                onClick={openDialog}
            />
            <ConfirmDialog
                title="Disable delivery bucket"
                text="Are you sure you want to disable this delivery bucket?"
                hidden={!isDialogOpen}
                confirm={{ onClick: handleDisable }}
                cancel={{ onClick: closeDialog }}
            />
        </>
    );
};
